import React, { useState, useEffect, useMemo } from "react";
import { Popup, Marker, Tooltip } from "react-leaflet";
import { createCustomPieChartMarker } from "./CustomMarker";
import { useDispatch } from "react-redux";
import SingleSystem from "./SingleSystem";
import Box from "@mui/material/Box";
import SensorContent from "./SensorContent";
import { refreshSignalR } from "../../../src/Dashboard/ducks/devicesDuck";
import { useCloudDevicesList, useCloudDevicesConfigs, useCloudSystemConfig, useCloudDeviceConfigEntries } from '../../hooks/useCloudSelectors';

const SensorMarker = ({ sys }) => {
  const dispatch = useDispatch();
  const sensorList = useCloudDevicesList(sys.deviceId);
  const sensorConfigs = useCloudDevicesConfigs(sys.deviceId);
  const systemConfig = useCloudSystemConfig(sys.deviceId);
  const configEntries = useCloudDeviceConfigEntries(sys.deviceId);

  const sensors = useMemo(() => {
    if (!sensorConfigs) return [];
    return Object.keys(sensorConfigs).map((key) => ({
      position: [sensorConfigs[key]?.gps?.lat, sensorConfigs[key]?.gps?.long],
      sensorData: sensorList?.find((s) => s.hwId === key),
    }));
  }, [sensorConfigs, sensorList]);

  useEffect(() => {
    if (sensors.length === 0 || !systemConfig) return;
    sensors.forEach((sensor) => {
      if (!sensor.sensorData?.hwId) return;
      dispatch(
        refreshSignalR({
          hwId: sensor.sensorData.hwId,
          payload: { ...systemConfig },
          delay: 700,
        })
      );
    });
  }, [sensors.length]);

  const [show, setShow] = useState(false);
  useEffect(() => {
    const timeout = setTimeout(() => setShow(true), 200);
    return () => clearTimeout(timeout);
  }, []);

  if (!show || sensors.length === 0) return null;

  return sensors.map((sensor) => {
    if (!sensor.sensorData) return null;
    return (
      <Marker
        position={sensor.position}
        icon={createCustomPieChartMarker(
          sensor.sensorData.deviceBgColor === "red" ? 1 : 0,
          sensor.sensorData.deviceBgColor === "orange" ? 1 : 0,
          sensor.sensorData.deviceBgColor === "green" ? 1 : 0,
          1,
          56,
          36
        )}
        key={sensor.sensorData.hwId}
      >
        <Tooltip direction="left">{sensor.sensorData.hwId}</Tooltip>
        <Popup autoPan={false} className="marker-popup" maxWidth={150}>
          <Box>
            <SensorContent
              sensor={sensor}
              sys={systemConfig}
              entries={configEntries}
            />
          </Box>
        </Popup>
      </Marker>
    );
  });
};

export default SensorMarker;
